<template>
  <div class="wrap">
    <div class="tech">
      <img :src="banner" alt="">
    </div>
    <div class="photo" v-if="tableList && tableList!=''">
      <table class="table" style="width: 100%;">
        <tr>
          <td v-for="tableitem in tableList" @click="goto_photo(tableitem.url)">
            <span>{{tableitem.date}}</span>
            <p>精彩瞬间,即时分享！</p>
          </td>
        </tr>
      </table>
    </div>
    <div class="demo">
      <ul class="list">
        <li v-for="item in dataList" @click="skip(item.id, item.type)">
          <div class="left">
            <img v-if="item.middlePicture || item.organizerLogo"
            :src="item.middlePicture">
            <p v-if="item.status == '直播中'"><img src="./../../../static/img/livving.png" style="height: 15px" alt=""></p>
            <p v-if="item.status == '直播'"><img src="./../../../static/img/living.png" style="height: 15px" alt=""></p>
            <p v-if="item.status == '即将开始'"><img src="./../../../static/img/nostart.png" style="height: 15px" alt=""></p>
            <p v-if="item.subjectType == 'live'"><img src="./../../../static/img/living.png" style="height: 15px" alt=""></p>
            <p v-if="item.status == '已结束'"><img src="./../../../static/img/livend.png" style="height: 15px" alt=""></p>
            <p v-if="item.status == '结束'"><img src="./../../../static/img/livend.png" style="height: 15px" alt=""></p>
            <p v-if="item.status == '视频回放'"><img src="./../../../static/img/replay.png" style="height: 15px;" alt=""></p>
            <p v-if="item.status == '回放'"><img src="./../../../static/img/replay.png" style="height: 15px" alt=""></p>
            <div v-if="item.play" class="Play"><img src="./../../../static/img/watch.png" alt=""></div>
          </div>
          <div class="right">
            <h3 class="title != null">{{item.title}}</h3>
            <p class="name" v-if="item.teacher != null">{{ item.teacher }}</p>
            <p class="name" v-if="item.teacherArr != null">大　咖：{{ item.teacherArr.truename }} {{ item.teacherArr.title }}</p>
            <p class="organizer"><span v-show="accountType == 2">大咖</span> <span v-show="accountType == 1">主办方</span>  ：{{ item.organizerName }}</p>
            <p class="liveTime" v-if="item.type != 'normal'">{{ item.liveTime }}</p>
            <p :class="item.price=='0.00' ? 'liveprice_green' : 'liveprice_red'" v-show="item.price&&item.price!=''">{{ item.price=='0.00'? '免费': '￥ '+item.price }}</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="buy_btn" v-show="data_buy.price&&data_buy.price!='0.00'" @click="ToBuy(data_buy.id)">整套购买 <span>￥{{ data_buy.price }}</span> </div>
    <returnPre></returnPre>
  </div>
</template>

<script>
  import api from 'api'
  export default {
    name: "technicaltopic",
    data () {
      return {
        banner:'',
        tableList:[],
            accountType: 1, // 1 主办方 2 嘉宾
            techurl:'',
            dataList: [],
            data_buy:[],
            axiosUrl: '', // 发送请求的地址
            uid: '',
            aid: '',
            orgName: '' // 主办方名称
          }
        },
        created () {
          const that = this
          // console.log('aid', this.$route.query)
          var aid = this.$route.query.aid
          this.techurl = 'api/subject/getMeetingInfo?mid=' + aid
          this.$axios.get(that.techurl).then(res => {
            // 如果lives数据为空，则跳转到会议介绍页面
            if (!res.data.data.lives) {
              window.location.href = 'https://www.itdks.com/Home/mobile/detail?id=' + aid + '&type=meet';
            }
            // console.log('返回',res)
            if (res.data.data.meetingInfo.uid) {
              this.uid = res.data.data.meetingInfo.uid
            }
            if (res.data.data.meetingInfo.organizer && res.data.data.meetingInfo.account_type == 1) {
              that.orgName = res.data.data.meetingInfo.organizer.replace('主办方：', '')
            }
            if (res.data.data.meetingInfo.price) {
              this.data_buy.price = res.data.data.meetingInfo.price
              this.data_buy.id = res.data.data.meetingInfo.id
            }
            // if (res.data.data.meetingInfo.myStatus&&res.data.data.meetingInfo.url!='') {
            //   this.data_buy.url = res.data.data.meetingInfo.url
            // }
            that.banner = res.data.data.meetingInfo.middlePicture;
            that.accountType = res.data.data.meetingInfo.account_type;
            if (res.data.data.lives !== null && res.data.data.lives.length > 0) {
              for (let i = 0; i < res.data.data.lives.length; i++) {
                if (res.data.data.lives[i].middlePicture.indexOf('http://www.apm.itdks.com') > -1) {
                  res.data.data.lives[i].middlePicture = res.data.data.lives[i].middlePicture.replace('www.apm', 'static')
                } // organizerName
                if (that.orgName) {
                  res.data.data.lives[i].organizerName = that.orgName
                }
              }
              that.dataList = res.data.data.lives;
            }
            if(res.data.data.meetingInfo.imgs_url !== null && res.data.data.meetingInfo.imgs_url.length > 0){
              that.tableList = res.data.data.meetingInfo.imgArr;
            }
            // console.log(that.tableList)
            // console.log(that.banner)
          })
        },
        beforeRouteEnter(to, from, next){
          next(vm =>{
            console.log(from.path)
          })
        },
        mounted() {
          this.initData()
        },
        methods: {
          // 初始化
          async initData() {
            const params = {
              targetType: 'meeting',
              targetId: this.$route.query.aid
            }
            const res = await api.common.getShareData(params)
            this.getShareInfo(true, res.data.shareTitle, res.data.shareDesc, res.data.shareImg);
            // this.getShareInfo22()
          },
          // 跳转
          skip(id, type) {
            window.location.href = 'https://www.itdks.com/Home/mobile/detail?id=' + id + '&type=' + type + '&mUid=' + this.uid
          },
          // 去相册
          goto_photo(photo_url){
            window.location.href =photo_url;
          },
          // 全套购买
          ToBuy(buyid){
            // window.location.href =url;
            window.location.href ='httsp://www.itdks.com/Act/sticket?id='+buyid+'&type=live';
          }
        }
      }
    </script>

    <style scoped lang="less">
    .wrap{
      position: relative;
      overflow-y: hidden;
      .tech{

        width: 100%;
        height: 400px;
        display: flex;
        justify-content: center;

        img{
          position: relative;
          margin: 0;
          width: 100%;
          height: inherit;
          text-align: center;

        }
      }
      .techscroll{

        }}
        * {
          margin: 0;
          padding: 0;
          outline: none;
        }
        h3{
          margin-top: -8px;
        }
        /*相册超链*/
        .photo {
          width: 100%;
          overflow: hidden;
          background: #fff;
          padding: 12px 0 12px 0;
          position: relative;
          border-bottom: 15px solid #E6E6E6;
          text-align:center;
        }
        .table{
          width: 100%;
          padding: 8px 0;
        }
        .table tr{
          width: 100%;
        }
        .table tr td{
          text-align: center;
          color: #eb803c;
          border-left: 1px solid #afa9a9;
          font-size: 25px;
          box-sizing: border-box;
          letter-spacing: 2px;
        }
        .table tr td:nth-child(1) {
          border: 0;
        }

        .demo {
          margin-bottom: 162px;
        }

        .demo .list li {
          /* width: 750px; */
          height: 219px;
          padding: 25px 28px;
          box-sizing: border-box;
          border-bottom: 1px solid #dedede; /*no*/
          list-style: none;
          .left {
            width: 270px;
            height: 169px;
            line-height: 169px;
            margin-right: 10px;
            float: left;
            border-radius: 10px;
            overflow: hidden;
            position: relative;
            display: flex;
            > img {
              width: 270px;
              height: 169px;
            }
            .Play {
              position: absolute;
              width: 50px;
              height: 50px;
              right: 5px;
              bottom: 55px;
              z-index: 10;
              img {
                width: 50px;
                height: 50px;
              }
            }
            p {
              position: absolute;
              line-height: 30px;
              left: -10px;
              color: #fff;
              top: -2px;
              font-size: 18px; /*px*/
              padding: 2px 10px;
            }
            .living {
            }
            .begin {

            }
            .agin {
            }
            .end {
            }
          }
          .right {
            width: 390px;
            margin-left: 20px;
            float: right;
            font-size: 24px; /*px*/
            .title {
              font-size: 28px; /*px*/
              // line-height: 56px;
              font-weight: 500;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .name {
              color: #f2845a;
              margin-top: 30px;
              margin-bottom: 6px;
              height: 32px;
              overflow: hidden;
              background: url(../../assets/img/title_ico.png) no-repeat left center;
              padding-left: 28px;
              background-size: 26px 26px;
            }
            .organizer {
              color: #f3855d;
              height: 36px;
              margin-top: 20px;
              text-overflow:ellipsis;
              white-space: nowrap;
              overflow: hidden;
              background: url(../../assets/img/title_ico.png) no-repeat left center;
              padding-left: 28px;
              background-size: 26px 26px;
            }
            .liveTime,
            .hitNum {
              font-size: 24px !important;
              color: #8c8c8c;
              span {
                float: right;
              }
            }
            .liveTime,.livetime{
              background: url(./../../assets/img/time_ico.png) no-repeat left center;
              padding-left: 28px;
              background-size: 26px 26px;
            }
            .hitNum {
              margin-top: 14px;
              span {
                color: #fe0200;
                font-weight: 700;
              }
            }
            .livetime {
              color: #8c8c8c;
              span {
                float: right;
              }
            }
            .liveprice_red{
              font-size: 24px !important;
              color: #f3855d;
              margin-top: 5px;
            }
            .liveprice_green{
              font-size: 24px !important;
              color:#559DD7;
              margin-top: 5px;
            }
            .pptNum{
              position: absolute;
              width: 30px;
              height: 30px;
              right: 20px;
              background: url(./../../assets/img/ppt_ico.png) no-repeat left top;
              padding-left: 30px;
              background-size: 26px 26px;
              margin-top: 10px;
            }
          }
        }
        .buy_btn{
          width: 5rem;
          height: 0.95rem;
          line-height: 0.95rem;
          text-align: center;
          font-size: 0.37rem;
          color: #fff;
          background: #0074BD;
          position: fixed;
          bottom: 1.2rem;
          right: 0;
          display:none;
        }
        .buy_btn span{
          margin-left:10px;
        }
      </style>



// WEBPACK FOOTER //
// src/components/HomePage-Children/Technicaltopic.vue